import React, { Component, Fragment } from "react";
import { Route, Switch, withRouter, Redirect } from "react-router-dom";
import { connect } from "react-redux";
import classNames from "classnames";
import { CssBaseline } from "@material-ui/core";
import Loadable from "react-loadable";

import { init } from "./actions";
import Cart from "./components/Cart";
import PageLoader from "./components/PageLoader";
import TitleBar from "./components/TitleBar";
import Footer from "./components/Footer";
import { AlertSnackbar } from "./components/Snackbar";

import Home from "./screens/Home";

import { isMobile } from "./userAgentDetect";

const Mosaic = Loadable({
  loader: () => import("./screens/Mosaic"),
  loading: props => <PageLoader backgroundColor="#ececec" {...props} />
});
const Privacy = Loadable({
  loader: () => import("./screens/Privacy"),
  loading: PageLoader
});
const AppPrivacy = Loadable({
  loader: () => import("./screens/AppPrivacy"),
  loading: PageLoader
});
const Terms = Loadable({
  loader: () => import("./screens/Terms"),
  loading: PageLoader
});
const About = Loadable({
  loader: () => import("./screens/About"),
  loading: PageLoader
});
const Faq = Loadable({
  loader: () => import("./screens/Faq"),
  loading: PageLoader
});
const Products = Loadable({
  loader: () => import("./screens/Products"),
  loading: PageLoader
});
const Product = Loadable({
  loader: () => import("./screens/Product"),
  loading: PageLoader
});
const Checkout = Loadable({
  loader: () => import("./screens/Checkout"),
  loading: props => <PageLoader backgroundColor="#f3f3f2" {...props} />
});
const SendCopy = Loadable({
  loader: () => import("./screens/Admin/SendCopy"),
  loading: PageLoader
});
const Affiliate = Loadable({
  loader: () => import("./screens/Affiliate"),
  loading: PageLoader
});

class App extends Component {
  // onInfoClose = () => {
  //   this.setState({ infoSnackOpen: false });
  // };
  componentDidMount() {
    this.props.init();
    if (window.isWebView) {
      alert("webview");
    }
  }
  render() {
    const { zenMode, webView } = this.props;
    return (
      <Fragment>
        <CssBaseline />
        <div
          className={classNames("fullscreen", {
            "fullscreen-mobile": isMobile
          })}
        >
          {!webView && <TitleBar />}
          <div
            className={classNames({
              page: !webView,
              "page--nobackground": zenMode || webView
            })}
          >
            <Switch>
              <Route exact path="/" component={Home} />
              {!isMobile && <Route path="/create/mosaic" component={Mosaic} />}
              {!isMobile && <Redirect from="/create" to="/create/mosaic" />}
              {/* {!isMobile && <Route path="/ceate" component={Create} />} */}
              <Route path="/products/:id" component={Product} />
              <Route path="/products" component={Products} />
              <Route path="/checkout" component={Checkout} />
              <Route path="/about" component={About} />
              <Route path="/faq" component={Faq} />
              <Route path="/privacy-policy" component={Privacy} />
              <Route path="/app/privacy-policy" component={AppPrivacy} />
              <Route path="/terms-and-conditions" component={Terms} />
              <Route path="/admin/sendcopy" component={SendCopy} />
              <Route path="/affiliate/:code" component={Affiliate} />
            </Switch>{" "}
            {!zenMode && <Footer />}
          </div>
        </div>
        {/* {isMobile && <BottomNav />} */}
        <AlertSnackbar />
        {/* <InfoSnack
          open={this.state.infoSnackOpen}
          onClose={this.onInfoClose}
          message="First 100 customers get a FREE Time Capsule (print-it-yourself version, worth USD$8.95)"
        /> */}
        <Cart />
      </Fragment>
    );
  }
}

const mapStateToProps = state => {
  const { pathname } = state.router.location;
  return {
    zenMode: pathname === "/checkout" || pathname.indexOf("/app") > -1,
    webView: pathname.indexOf("/app") > -1
  };
};
export default withRouter(
  connect(
    mapStateToProps,
    { init }
  )(App)
);



// WEBPACK FOOTER //
// ./src/App.js